import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import LoadingDataSpinner from "@/components/Frontend/LoadingDataSpinner";
import { URLS } from "@/utils/urls";

const privacyPolicy = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [content, setContent] = useState<string>('');

    useEffect(() => {
        fetchAboutUs();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchAboutUs = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(URLS?.privacyPolicy(1), {
                headers: { "Content-Type": "application/json" },
            });
            if (response.ok) {
                const data = await response.json();
                setContent(data.content);
            } else {
                console.error("Failed to fetch data");
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='mt-10 px-[186px] sm:px-[15px] flex flex-col gap-5'>
            <div className='flex flex-col items-center justify-center gap-2'>
                <h2 className='text-[30px] font-extrabold text-[#555] tracking-wide capitalize'>Privacy & Policy</h2>
                <p className='text-[#777] tracking-wide text-[14px] font-light whitespace-nowrap	'>Welcome to the HotBuyMart multivendor marketplace</p>
            </div>

            {isLoading ? (
                <LoadingDataSpinner />
            ) : <div>
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} className='text-[#777777] text-[14px] leading-[26px]'></p>
            </div>
            }
        </div>
    )
}

export default privacyPolicy